export function LeafIcon() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.701 7.09067C19.5488 11.5564 18.7409 15.6995 14.3599 17.2278C12.228 17.9721 10.7743 17.5652 9.86414 17.064C9.70456 17.6297 9.60233 18.5303 9.59983 19.3043C9.59983 19.6517 9.43277 19.8601 9.17844 19.9494C8.67725 20.1255 8.12369 19.8303 7.91923 19.2473C7.60006 18.3442 8.1985 16.997 8.64982 16.1461C9.57739 14.3846 11.1957 13.5039 12.6269 12.6901C14.1305 11.8367 15.2999 11.0031 15.482 9.57409C15.5243 9.23916 15.1129 9.21931 15.0032 9.455C14.32 10.9436 13.2503 11.3951 11.9836 11.9732C10.7169 12.5512 9.20088 13.1764 8.31569 14.9825C7.9317 15.7665 7.45045 14.5781 7.34324 14.2755C6.25109 11.1867 7.84442 8.86454 10.9987 7.763C12.026 7.40327 13.2727 7.13036 14.2402 6.90956C15.3897 6.64658 16.8459 6.11318 17.5715 6.01146C18.2971 5.90974 18.5888 6.50269 18.6985 7.09067H18.701Z"
        fill="currentColor"
      />
    </svg>
  )
}
